<app-navbar></app-navbar>
<main role="main">
  <router-outlet></router-outlet>
</main>
<app-footer></app-footer>
<div class="mobile-sticky-cta" aria-label="Quick contact actions">
  <a href="tel:512-848-1316">Call/Text</a>
  <a routerLink="/contact">Schedule</a>
</div>
